import React from "react";
import {
  ResponsiveContainer,
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
} from "recharts";

const RevenueProfitChart = ({ data }) => {
  return (
    <div className="card border-0 shadow-sm">
      <div className="card-header bg-white border-0">
        <h5 className="mb-0">
          Revenue vs Profit
        </h5>
      </div>

      <div className="card-body">
        <ResponsiveContainer width="100%" height={350}>
          <LineChart data={data}>
            <CartesianGrid strokeDasharray="3 3" />

            <XAxis dataKey="month" />

            <YAxis />

            <Tooltip
              formatter={(value) =>
                `₹${Number(value).toLocaleString("en-IN")}`
              }
            />

            <Legend />

            <Line
              type="monotone"
              dataKey="revenue"
              stroke="#0d6efd"
              strokeWidth={3}
              dot={{ r: 4 }}
              name="Revenue"
            />

            <Line
              type="monotone"
              dataKey="profit"
              stroke="#198754"
              strokeWidth={3}
              dot={{ r: 4 }}
              name="Profit"
            />
          </LineChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};

export default RevenueProfitChart;
